module.exports = __webpack_public_path__ + "img/yygl.1d713648.png";